"use strict";

function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var React = _interopRequireWildcard(require("react"));
var _react2 = require("@fluentui/react");
var _ExternalLink = require("../../../Shared/Components/ExternalLink");
var _Shared = require("../../../Shared");
function _getRequireWildcardCache(nodeInterop) {
  if (typeof WeakMap !== "function") return null;
  var cacheBabelInterop = new WeakMap();
  var cacheNodeInterop = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) {
    return nodeInterop ? cacheNodeInterop : cacheBabelInterop;
  })(nodeInterop);
}
function _interopRequireWildcard(obj, nodeInterop) {
  if (!nodeInterop && obj && obj.__esModule) {
    return obj;
  }
  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
    return {
      default: obj
    };
  }
  var cache = _getRequireWildcardCache(nodeInterop);
  if (cache && cache.has(obj)) {
    return cache.get(obj);
  }
  var newObj = {};
  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var key in obj) {
    if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) {
      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
      if (desc && (desc.get || desc.set)) {
        Object.defineProperty(newObj, key, desc);
      } else {
        newObj[key] = obj[key];
      }
    }
  }
  newObj.default = obj;
  if (cache) {
    cache.set(obj, newObj);
  }
  return newObj;
}
var ReadonlyDirectOwners = function ReadonlyDirectOwners(props) {
  var _props$artifactOwners = props.artifactOwnership,
    justification = _props$artifactOwners.justification,
    owners = _props$artifactOwners.owners;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("ul", {
    className: "margin-0 ownership-block-".concat(_Shared.OwnerType.PERSON)
  }, owners.map(function (ownerEmail) {
    return /*#__PURE__*/React.createElement("li", {
      key: ownerEmail
    }, /*#__PURE__*/React.createElement(_ExternalLink.ExternalLink, {
      link: "mailto:".concat(ownerEmail),
      metricsTag: "RepositoryOwnerPanel.EmailDirectOwner",
      text: ownerEmail
    }));
  })), /*#__PURE__*/React.createElement(_react2.Text, {
    block: true,
    className: "margin-top-8"
  }, t("repositoryOwnerPanel.assign.repositoryOwner.justificationReadonly"), /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("div", {
    style: {
      whiteSpace: "pre"
    }
  }, justification)));
};
var _default = ReadonlyDirectOwners;
exports.default = _default;